import { Link } from "react-router-dom";
import { ArrowRight, Phone, Mail, MapPin } from "lucide-react";

const QUICK_LINKS = [
  { to: "/plans", label: "View Plans" },
  { to: "/about", label: "About Us" },
  { to: "/gallery", label: "Repair Gallery" },
  { to: "/get-id", label: "Get Customer ID" },
  { to: "/lookup", label: "Customer Lookup" },
  { to: "/enquire", label: "Book Enquiry" },
  { to: "/feedback", label: "Feedback" },
  { to: "/admin", label: "Admin" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A1626] border-t border-[#223851]" data-testid="main-footer">
      <div className="max-w-[1300px] mx-auto px-5 sm:px-8 py-16">
        {/* CTA band */}
        <div className="rounded-3xl bg-gradient-to-br from-[#142B42] to-[#0F2236] border border-[#223851] p-8 md:p-14 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white leading-tight">
              Keep your home running{" "}
              <span className="text-[#F26A21]">like new.</span>
            </h2>
            <p className="text-[#AEBECD] mt-3 max-w-md">
              Start a yearly plan today — certified technicians, genuine parts,
              fixed pricing.
            </p>
          </div>
          <Link
            to="/get-id"
            data-testid="footer-cta"
            className="shrink-0 inline-flex items-center gap-2 bg-[#F26A21] text-white px-7 py-4 rounded-full font-semibold hover:bg-[#DE5C15] transition-colors duration-300 group"
          >
            Start a plan
            <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mt-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-xl bg-white flex items-center justify-center overflow-hidden p-0.5">
                <img src="/asa-logo.jpeg" alt="ASA logo" className="w-full h-full object-contain" />
              </span>
              <span className="font-heading font-extrabold text-xl text-white">ASA</span>
            </div>
            <p className="text-[#AEBECD] mt-4 max-w-sm leading-relaxed">
              ASA Home Appliance Services — annual maintenance plans for every
              appliance in your home.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-[#6B7E92] mb-4">Contact</p>
            <ul className="space-y-3 text-[#AEBECD]">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#F26A21] shrink-0" />
                <a href="tel:+919059223423" className="hover:text-[#F26A21] transition-colors">+91-9059223423</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#F26A21] shrink-0" />
                <a href="tel:+917386685959" className="hover:text-[#F26A21] transition-colors">+91-7386685959</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#F26A21] shrink-0" />
                <a href="mailto:asahomeappliancesservices@gmail.com" className="hover:text-[#F26A21] transition-colors break-all">asahomeappliancesservices@gmail.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#F26A21] shrink-0 mt-1" />
                <span>Plot No 186B, Allwyn Colony, V V Nagar, Kukatpally, HYD TS-500 072</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[#6B7E92] mb-4">Quick Links</p>
            <ul className="space-y-3 text-[#AEBECD]">
              {QUICK_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="hover:text-[#F26A21] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#223851] flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-sm text-[#6B7E92]">© {new Date().getFullYear()} ASA Home Appliance Services</p>
          <p className="text-sm text-[#6B7E92]">Certified care, all year long.</p>
        </div>
      </div>
    </footer>
  );
}
